import React, { useContext, useEffect, useState, useRef } from 'react';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../users/TableIcons';
import app from '../../../../authentication/firebaseStart';
import { AuthContext } from '../../../../authentication/Auth';
import Pagination from '../../../users/components/Pagination';
import ApsToolbar from '../../../users/components/ApsToolbar';
import styled from "styled-components";
import DropdownCustom from '../../../../components/DropdownCustom';
import GoBack from '../../../../components/GoBack';
import { useTranslation } from "react-i18next";
import { Tooltip } from '@material-ui/core';

import DropdownWithBorders from '../../../../components/DropdownWithBorders';


const ErrorLine = styled.p`
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    margin-left: 14px;
    color: #f44336;
`
const CuzCell = styled.p`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const BacknTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`;

const PageTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 27px;
  margin-bottom: 5px;
  color: #007ABA;
  width: 100%;
  @media screen and (max-width: 700px){
    flex-direction: column;
  }
`
const TitleNDropdown = styled.span`
  margin-left: 20px;
`

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
  @media screen and (max-width: 750px) {
    margin-top: 35px;
  }
`;

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
`;

const DropDownWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // flex-direction: column;
    label{
      font-weight: 500;
      margin: 0;
      // color: #1386c1;
      font-size: 15px;
    }
`;

const SiteData = styled.div`
    display: flex;
    margin-bottom: 8px;
`;

const SiteNameLabel = styled.div`
  font-weight: 500;
  ${'' /* width: 1000px; */}
`;

const StyledTextField = styled.div`
  margin-left: 10px;
`;  

const firestore = app.firestore(); 

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`;


const Formcontainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 10px;
`


const LabelText = styled.label`
    color: #4f4f4f;
    font-size: 14px;
`
export default function SiteFilter(props) {
  //Loader 
  const [isLoading, setIsLoading] = useState(false);

  //pagination
  const [TotalData, setTotalData] = useState(0)
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  //Data
  const [ApsData, setApsData] = useState([])
  const DEFAULT_SITE = { label: "Select", value: "" };
  const [initSiteData, setInitSiteData] = useState([]);
  const [siteDatas, setsiteData] = useState();
  const context = useContext(AuthContext);
  const companyID = context.currentUser.claims.companyID;
  const { t } = useTranslation();
  const isManager = context.currentUser.claims.isManager;
  const siteNameAssigned = context.currentUser.claims.siteName;

  //Filter
  //const [APS_SITE_FILTER, set_APS_SITE_FILTER] = useState({DEFAULT_SITE});

  //const [APS_ACCESS_FILTER, set_APS_ACCESS_FILTER] = useState('')
  //const [APS_SEARCH_FILTER, set_APS_SEARCH_FILTER] = useState(['', ''])

  const onSiteSelected = props.onSiteSelected;

  //Just set the seletedValue based on the Sitepassed
  //This will not maintain the state of the selected item. It will be maintained @ the caller end
  //Just form the object
  var selectedValue = {
    label: (props.siteName == "" || props.siteName == null) ? "Select": props.siteName,
    value: props.siteName
  };

  useEffect(() => {
    getInitialSitesData();
    //getAPSData();

    //selectedValue = DEFAULT_SITE;
  }, [
    //APS_SITE_FILTER,
    //APS_ACCESS_FILTER,
    //APS_SEARCH_FILTER,
    pageSize
  ]);


  // async function getAPSData(pageIncrement = 0) {
  //   try {
  //     setIsLoading(true);

  //     let QUERY = buildAPSQuery();
  //     let dataLimit = pageSize;

  //     setTotalData(await QUERY.get().then((snapshot) => snapshot.size))
  //     setCurrentPage(pageIncrement == 0 ? 0 : currentPage + pageIncrement)

  //     if (APS_SEARCH_FILTER[0]) { dataLimit = 100 }
  //     else {
  //       if (pageIncrement != 0 && ApsData.length >= 1) {
  //         if (pageIncrement == 1) { QUERY = QUERY.startAfter(ApsData[ApsData.length - 1]?.apMacAddress).limit(dataLimit) }
  //         else if (pageIncrement == -1) { QUERY = QUERY.endBefore(ApsData[0]?.apMacAddress).limitToLast(dataLimit) }
  //       }
  //       else { QUERY = QUERY.limit(dataLimit) }
  //     }

  //     setApsData((await QUERY.get()).docs.map((doc) => doc.data()))
  //     setIsLoading(false);
  //   } catch (err) { onError(err) }
  // }

  // let buildAPSQuery = () => {
  //   try {
  //     //Basic Query
  //     let query = firestore.collection('tenants').doc(companyID).collection('Aps');

  //     //Site Filter
  //     if ((APS_SITE_FILTER && APS_SITE_FILTER?.value != 'All Sites') || isManager) {
  //       query = query.where('siteName', '==', isManager ? siteNameAssigned.toUpperCase() : APS_SITE_FILTER?.value.toUpperCase())
  //     }

  //     // Filter DropDown Filter
  //     if (APS_ACCESS_FILTER) {
  //       if (APS_ACCESS_FILTER?.value == 'Location friendly names not assigned') {
  //         query = query.where('apFriendlyName', '==', '')
  //       } else if (APS_ACCESS_FILTER?.value == 'Sites not assigned') {
  //         query = query.where('siteName', '==', '')
  //       }
  //     }

  //     //Search Text
  //     let SearchTxt = APS_SEARCH_FILTER[0].toUpperCase();
  //     let SearchField = APS_SEARCH_FILTER[1];
  //     if (SearchTxt) {
  //       if (SearchField == 'apMacAddress') {
  //         query = query.orderBy('apMacAddress').startAt(SearchTxt).endAt(SearchTxt + "\uf8ff")
  //       } else {
  //         query = query.orderBy(SearchField).orderBy('apMacAddress', 'desc').startAt(SearchTxt).endAt(SearchTxt + "\uf8ff")
  //       }
  //     } else {
  //       query = query.orderBy('apMacAddress', 'desc')
  //     }

  //     return query
  //   } catch (err) { onError(err) }
  // }

  let changeOnFilter = (data) => {

    //Set the filter.
    //set_APS_SITE_FILTER(data?.target);
    //Call the filter selected
    onSiteSelected(data.value);
  }

 
  let getInitialSitesData = async () => {
    try {
      if (initSiteData?.length <= 1) {
        let sites =[];
    
        let siteData = (
          await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('SiteLocations')
            .orderBy('displaySiteName')
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());

          //Push defaut value
          sites.push(DEFAULT_SITE);

        //Add all the sites
        siteData.forEach(element => {
          sites.push({ label: element.siteName, value: element.siteName })
        });
      
       
      setInitSiteData(sites)
      setsiteData(sites);
    }
     
    } catch (err) { onError(err) }
  }

  let getSelectInputSearch = async (rawInput, type) => {
    try {
      if (type === 'ENTERHIT' && rawInput) {
        let sites = [];
        setIsLoading(true);

          //get all the sites
        sites = (
          await firestore
            .collection('tenants') 
            .doc(companyID)
            .collection('SiteLocations')
            .orderBy('siteName')
            .startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());
        
        let finalSitesArray = [];
       
        //Push defaut value
        finalSitesArray.push(DEFAULT_SITE);

        if (sites.length > 0) {
          sites.forEach(element => {
            finalSitesArray.push({ label: element.siteName, value: element.siteName })
          });
        }
        setsiteData(finalSitesArray)
        setIsLoading(false);
      }
    } catch (err) { onError(err) }
  }

  const onError = (err) => {
    console.log(err);
    setIsLoading(false);
  }

  return (<Formcontainer>
    <LabelText>{t('Mo_Dash.placeholders.sitename')}</LabelText>
    <DropdownWithBorders
         selectOpts={siteDatas}
         onChange={(e) => changeOnFilter(e)}
         isClearable = {true}
         selectVal = { selectedValue } 
         isSearchable={ !isManager } 
         onSearchInpChange={getSelectInputSearch}
         isLoading={isLoading}
         customFilterOption={() => { return siteDatas }}
         selectOnBlur={() => { }} 
    />
   
</Formcontainer>
);

}

